import { APP_ROUTES } from '@/common/constants'
import { getAccountRouteMode, isClientsRoute } from '@/common/navigation/accountRoutes'
import type { Account } from '@/common/types'

type RouteMatcher = (pathname: string) => boolean

export type AppShellVisibility = {
    isFullViewRoute: boolean
    showMobileBottomNav: boolean
    showInstrumentSearch: boolean
    showFooter: boolean
}

const exactRoute =
    (route: string): RouteMatcher =>
    (pathname) =>
        pathname === route

const fullViewRouteMatchers: RouteMatcher[] = [
    isClientsRoute,
    exactRoute(APP_ROUTES.APPLICATION_CREATE),
    exactRoute(APP_ROUTES.APPLICATION_KYC_CONFIRM),
]

// Account-details edit forms (Trade Confirmation, Registration Address, TFN): their fixed
// mobile action bar sits where the mobile bottom nav would render, so the nav is hidden on
// these routes only — unlike fullViewRouteMatchers, the desktop sidebar and instrument search
// stay visible, since only the mobile bottom nav collides here.
const accountDetailsEditRouteMatchers: RouteMatcher[] = [
    exactRoute(APP_ROUTES.ACCOUNT_TRADE_CONFIRMATION),
    exactRoute(APP_ROUTES.ACCOUNT_REGISTRATION_ADDRESS),
    exactRoute(APP_ROUTES.ACCOUNT_TFN),
]

export const getAppShellVisibility = ({
    pathname,
    primaryAccount,
    activeAccountId,
}: {
    pathname: string
    primaryAccount: Account | null
    activeAccountId: string | null
}): AppShellVisibility => {
    const isFullViewRoute =
        fullViewRouteMatchers.some((matches) => matches(pathname)) ||
        getAccountRouteMode({ pathname, primaryAccount, activeAccountId }) === 'adviser-full'
    const isAccountDetailsEditRoute = accountDetailsEditRouteMatchers.some((matches) => matches(pathname))

    return {
        isFullViewRoute,
        showMobileBottomNav: !isFullViewRoute && !isAccountDetailsEditRoute,
        showInstrumentSearch: !isFullViewRoute,
        showFooter: pathname !== APP_ROUTES.MORE && !isAccountDetailsEditRoute,
    }
}
